// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Accordion_wrapper__QavBT","title":"Accordion_title__X_wr_","left":"Accordion_left__sOzCS","center":"Accordion_center__GhRSh","right":"Accordion_right__pFhNV"};